/* global SelectAttendeesVariant */
"use strict";

($dt => {

	// Localized Constants
	const { DEBOUNCE_DEFAULT } = $dt.TopicGrid.Constants;

	// Localized Functions
	//const { consoleLog } = $dt.TopicGrid.Functions;

	// Localized Functions
	//const { } = $dt.TopicGrid.Functions;

	class ThisVariant extends SelectAttendeesVariant {
		/**
		 * @param {string} key 
		 * @param {HTMLElement} select_attendees_elem
		 * @param {Block} block
		 * @param {InnerScreen} screen
		 */
		constructor(key, select_attendees_elem, block, screen) {
			super(key, select_attendees_elem, block, screen);
			this.wrapper_elem = this.select_attendees_elem.querySelector('.increment-addons');
			this.addon_elem = this.wrapper_elem.querySelector('input[name="num_attendees_addons"]');
			
			//consoleLog('Created AddOn Variant', key, this);
		}

		setup() {
			this.setup_text_input_addons();
			this.setup_increments_addons();
		}

		setup_text_input_addons() {
			// Localize
			const { addon_elem, block } = this;

			// Update Functions
			const update_addons_value = () => {
				const { scheduling_info, current_topic } = block;
				const { addon } = current_topic;

				if (addon_elem.value.length > 0) {
					try {
						let value = parseInt(addon_elem.value);
						if (!value || value < addon.minimum_amount) {
							value = addon.minimum_amount;
						} else if (value > addon.maximum_amount) {
							value = addon.maximum_amount;
						}

						addon_elem.value = value;
						if (scheduling_info.addon_attendees !== value) {
							scheduling_info.addon_attendees = value;
						}

						// Refresh Ajax (price updates)
						this.screen.RefreshAjax(true);

						// Allow Next
						//this.screen.ScreenIsValid();
					} catch (err) {
						// couldn't parse text input
						addon_elem.value = '';
					}
				} else {
					
				}
			};

			// Changing attendees by typing or adjusting using device incrementers
			addon_elem.addEventListener('keyup', $dt.Util.debounce(update_addons_value, DEBOUNCE_DEFAULT));
			addon_elem.addEventListener('change', $dt.Util.debounce(update_addons_value, DEBOUNCE_DEFAULT));
		}

		setup_increments_addons() {
			// Localize
			const { addon_elem, block } = this;

			// Get Button Elems
			const incrementor_elems = this.select_attendees_elem.querySelectorAll('.increment-addons .number-increment');

			// +/- buttons
			incrementor_elems.forEach(button_elem => {
				const direction = button_elem.getAttribute('data-direction');

				// One event for clickers
				button_elem.addEventListener('click', () => {
					const { scheduling_info, current_topic } = block;
					const { addon } = current_topic;

					if (addon_elem.value.length === 0) {
						addon_elem.value = addon.minimum_amount;
					}
					try {
						let value = parseInt(addon_elem.value);
						if (direction === 'down') {
							if (value > addon.minimum_amount) {
								value--;
							} else {
								value = addon.minimum_amount;
							}
						} else {
							if (value < addon.maximum_amount) {
								value++;
							} else {
								value = addon.maximum_amount;
							}
						}

						if (scheduling_info.addon_attendees !== value) {
							scheduling_info.addon_attendees = value;
							addon_elem.value = value;
						}

						// Refresh Ajax (price updates)
						this.screen.RefreshAjax(true);
					} catch (err) {
						// Couldn't parse value
						addon_elem.value = '';
					}
				});

				// Another debounced event for refreshing the calendar
				button_elem.addEventListener('click', $dt.Util.debounce(() => {
					// Refresh Ajax (price udpates)
					this.screen.RefreshAjax(true);
				}, DEBOUNCE_DEFAULT));
			});
		}

		show() {
			const { wrapper_elem, addon_elem, block } = this;
			const { scheduling_info, current_topic } = block;

			const labelElem = wrapper_elem.querySelector('.addons-plu-name');

			if (current_topic.addon) {
				wrapper_elem.classList.add('addon-plu-active');

				if (labelElem) {
					labelElem.innerHTML = current_topic.addon.plu_name + ':';
				}

				// Set inputs
				if (scheduling_info.addon_attendees) {
					addon_elem.value = scheduling_info.addon_attendees;
				} else {
					addon_elem.value = current_topic.addon.minimum_amount;
					scheduling_info.addon_attendees = current_topic.addon.minimum_amount;
				}
			} else {
				wrapper_elem.classList.remove('addon-plu-active');
				addon_elem.value = '';
				if (labelElem) {
					labelElem.innerHTML = '';
				}
			}
		}
	}
	
	/**
	 * 
	 * @param {HTMLElement} select_attendees_elem 
	 * @param {Block} block 
	 * @param {InnerScreen} screen
	 * @returns {ThisVariant}
	 */
	const createAddOnVariant = (select_attendees_elem, block, screen) => {
		return new ThisVariant(null, select_attendees_elem, block, screen);
	};

	// Save to object
	$dt.TopicGrid.SelectAttendees.createAddOnVariant = createAddOnVariant;

})(window.d3_wp_themejs);
